var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"medialib"},[_c('h2',{staticClass:"large-title medialib__title"},[_vm._v("Media Library")]),_c('adx-media',{ref:"media",attrs:{"display":_vm.display}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }